import { render, staticRenderFns } from "./ExhibitorPageMessage.vue?vue&type=template&id=57e55627&scoped=true"
import script from "./ExhibitorPageMessage.vue?vue&type=script&lang=ts"
export * from "./ExhibitorPageMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e55627",
  null
  
)

export default component.exports